import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export default function ChevronDownIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M11.97 17.5a1.49 1.49 0 0 1-1.06-.43l-5.97-6a1.5 1.5 0 0 1 2.12-2.13l4.91 4.97 4.93-4.77a1.5 1.5 0 0 1 2.44 1.68c-.1.18-.22.34-.38.48l-5.97 5.79c-.28.26-.64.41-1.02.42Z"/>
        </SvgIcon>
    )
}
